import Vue from 'vue'

export default {
    loadFooter () {
        const requestData = {
            'query': `{
              globals {
                footer {
                  textInput
                  footerLinks {
                    ...on FooterLinksLinks {
                      emailLink
                      instagramLink
                      facebookLink
                    }
                  }
                }
              }
            }`
        }
        return Vue.axios.post('', requestData)
    }
}